module.exports = __webpack_public_path__ + "img/icon1-1.7d27d743.png";